import LocationListItem from "./LocationListItem";

export default function LocationListRow({ letter, locations, centerIcon, memorialIcon }) {
  return (
    <div>
      <div className="my-12 flex" id={letter}>
        <a href={`#${letter}`} className="w-16 text-lg font-bold">
          {letter}
        </a>
        <ul className="flex-grow location-list-row">
          {locations.map((location) => (
            <LocationListItem
              key={location.id}
              id={location.id}
              slug={location.slug}
              title={location.title}
              isPlaceOfHome={location.is_place_of_home}
              hasMemorial={location.has_memorial}
              type={location.type.value}
              centerIcon={centerIcon}
              memorialIcon={memorialIcon}
            />
          ))}
        </ul>
      </div>
      <hr />
    </div>
  );
}
